import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RegistrationRoutingGuard } from "./registration/registration-routing-guard.guard";
import { AdminRoutingGuard } from "./admin/admin-routing-guard.guard";
import { StalkerRoutingGuard } from "./stalker/stalker-routing-guard.guard";
import { ErrorComponent } from "./error/error.component";
import { AppComponent } from "./app.component";

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./loading/loading.module").then((m) => m.LoadingModule),
    runGuardsAndResolvers: "always",
  },
  {
    path: "error",
    component: ErrorComponent,
  },
  {
    path: "home",
    loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
    runGuardsAndResolvers: "always",
  },
  {
    path: "admin",
    loadChildren: () => import("./admin/admin.module").then((m) => m.AdminModule),
    runGuardsAndResolvers: "always",
    canActivate: [AdminRoutingGuard],
  },
  {
    path: "registration",
    loadChildren: () => import("./registration/registration.module").then((m) => m.RegistrationModule),
    runGuardsAndResolvers: "always",
    canActivate: [RegistrationRoutingGuard],
  },
  {
    path: "stalker",
    loadChildren: () => import("./stalker/stalker.module").then((m) => m.StalkerModule),
    runGuardsAndResolvers: "always",
    canActivate: [StalkerRoutingGuard],
  },
  // {
  //   path: "*",
  //   loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
  //   runGuardsAndResolvers: "always",
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
